/* @flow */
import apiRequest from 'lib/apiRequest';

export type QuickActionDataType = {
  chat_uuid?: ?string,
  user: {
    initials: string,
    color: string,
    name: string,
    id: number,
  },
};

export type QuickActionType = {
  uid: string,
  data?: QuickActionDataType,
};

export const QuickActionUIDs = {
  ADD_PEOPLE: 'add_people',
  CREATE_GROUP_CHAT: 'create_group_chat',
  SHOW_HISTORY: 'show_history',
  CREATE_ACTIVITY: 'create_activity',
  DIVIDER: 'vertical_divider',
  PERSON: 'person',
};

export function loadQuickActionsForGroup(groupId: number): Promise<QuickActionType[]> {
  return apiRequest(`/classes/${groupId}/quick_actions`, 'GET').then(response => response.actions);
}



// WEBPACK FOOTER //
// ./src/entities/QuickActions.js